


















import QErrors from "@/common/qErrors.vue";
import { Component, Prop, PropSync } from "vue-property-decorator";
import { Vue } from "vue-property-decorator";

@Component({
  name: "qSelect",
  components: { QErrors },
})
export default class qSelect extends Vue {
  @PropSync("value", {
    default: null,
  })
  public valueSync;

  @Prop({
    default: false,
  })
  public required;

  @Prop({
    type: String,
    required: true,
  })
  public name;

  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public errors;

  public change() {
    this.$emit("update:errors", { ...this.errors, ...{ [this.name]: [] } });
    this.$emit("changeCategory");
    this.$emit("changeSubCategory");
  }
}
